import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchPublicRedirects } from "@/lib/api";

/**
 * Listens to route changes and applies any admin-configured redirects.
 * External URLs (starting with http) do a full window.location.replace.
 * Internal paths use window.history + reload of app router.
 */
export default function RedirectHandler() {
    const location = useLocation();
    const { data } = useQuery({
        queryKey: ["public-redirects"],
        queryFn: fetchPublicRedirects,
        staleTime: 60 * 1000,
        refetchInterval: 5 * 60 * 1000,
    });

    useEffect(() => {
        const items = data?.items || [];
        if (!items.length) return;
        const path = location.pathname;
        const hit = items.find((r) => r.from_path === path);
        if (!hit) return;
        const to = hit.to_url || "";
        if (!to) return;
        // Prefer replace so back button doesn't return here
        if (/^https?:\/\//i.test(to)) {
            window.location.replace(to);
        } else {
            const target = to.startsWith("/") ? to : `/${to}`;
            if (target !== path) window.location.replace(target);
        }
    }, [location.pathname, data]);

    return null;
}
